var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2048,
    height: 2048,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:none}.fil2{fill:#689f38;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M0 0h2048v2048H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M255.999 255.999h1536v1536h-1536z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M255.999 255.999h1536v1536h-1536z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M606.684 738.044c578.1 150.763 157.228 857.642 731.209 977.992l-5.146 59.666c-596.624-53.635-191.968-812.464-740.423-979.092-1.263-.483-2.099-.8-7.402-2.88l21.762-55.686z",
    style: {
      fill: "#757575",
      fillRule: "nonzero"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1332.75 825.043h.004l1.117.007c80.582.301 153.617 33.19 206.574 86.145 53.2 53.203 86.152 126.666 86.152 207.691 0 23.333-2.752 46.075-7.945 67.917-5.276 22.19-13.167 43.555-23.332 63.755l-235.658 485.954-26.81 55.284-.099.204-.002-.005v-557.03h.003l.685-.004c31.725-.185 60.482-13.169 81.356-34.04 21.025-21.026 34.049-50.044 34.049-82.036 0-31.997-13.022-61.021-34.047-82.046-20.82-20.82-49.486-33.792-81.113-34.042l-.93-.006h-.003V825.042z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1038.9 1118.89c0-81.025 32.953-154.488 86.154-207.69 53.2-53.2 126.666-86.152 207.691-86.153v177.749c-31.996 0-61.018 13.024-82.043 34.049-21.098 21.098-34.167 50.126-34.167 82.043h.119v.002c0 31.99 13.025 61.01 34.05 82.035 21.024 21.021 50.045 34.044 82.041 34.045V1792l-26.904-55.484-235.705-486.056c-10.153-20.186-18.03-41.527-23.298-63.69a293.207 293.207 0 0 1-7.939-67.88z",
    style: {
      fill: "#7cb342",
      fillRule: "nonzero"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "m584.984 794.235-26.907-55.49-119.32-246.074c-5.651-11.245-10.02-23.074-12.924-35.293a163.294 163.294 0 0 1-4.427-37.804c0-45.105 18.345-86.003 47.96-115.617C498.98 274.344 539.879 256 584.984 256v72.733c-24.036.012-45.835 9.8-61.63 25.596-15.86 15.86-25.684 37.68-25.684 61.674h.088v.002c0 24.047 9.791 45.862 25.597 61.667 15.795 15.792 37.593 25.58 61.629 25.593v290.971z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m584.985 255.999.983.006c44.716.264 85.236 18.554 114.636 47.953 29.613 29.614 47.958 70.512 47.958 115.617 0 12.967-1.534 25.624-4.428 37.797-2.903 12.22-7.275 24.058-12.922 35.323l-119.317 246.05-26.753 55.171-.156.321-.001-.002V503.264h.046l.557-.004c23.831-.15 45.434-9.91 61.115-25.588 15.804-15.806 25.596-37.62 25.596-61.668 0-24.054-9.79-45.872-25.595-61.677-15.623-15.624-37.122-25.368-60.847-25.59l-.826-.005h-.046V256z",
    style: {
      fill: "#558b2f",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteView);
export default __webpack_public_path__ + "static/media/route-view.916f5cd12c60f70c6d00455e911ea3b3.svg";
export { ForwardRef as ReactComponent };